import { HStack } from '@cbhq/cds-web/layout';
import { AvatarSize } from '@cbhq/cds-common';
import { RemoteImage } from '@cbhq/cds-web/media';
import { getTokenImageUrl } from '@/utils/equityImages';

type Props = {
  baseSymbol: string;
  quoteSymbol: string;
  size?: AvatarSize;
};

/**
 * Token icons for the Explore page using actual asset images
 */
export function ExploreListTokensMedia({ baseSymbol, quoteSymbol, size = 'l' }: Props) {
  const baseImageUrl = getTokenImageUrl(baseSymbol);
  const quoteImageUrl = getTokenImageUrl(quoteSymbol);

  const tokens = [
    { symbol: baseSymbol, imageUrl: baseImageUrl },
    { symbol: quoteSymbol, imageUrl: quoteImageUrl },
  ];

  const overlap = size.includes('xxl') ? -3 : -2;

  return (
    <HStack gap={0}>
      {tokens.map((token, index) => (
        <RemoteImage
          key={token.symbol}
          source={token.imageUrl}
          size={size}
          shape="circle"
          marginEnd={index < tokens.length - 1 ? overlap : 0}
          style={{
            zIndex: tokens.length - index,
            border: '2px solid var(--background, white)',
          }}
        />
      ))}
    </HStack>
  );
}
